module.exports = __webpack_public_path__ + "static/media/cup-disc.a7db43cb.svg";